import { render, staticRenderFns } from "./ComplaintCreate.vue?vue&type=template&id=adffb702"
import script from "./ComplaintCreate.vue?vue&type=script&lang=js"
export * from "./ComplaintCreate.vue?vue&type=script&lang=js"
import style0 from "./ComplaintCreate.vue?vue&type=style&index=0&id=adffb702&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports